/**
 * theme.js — Design token constants for JS/SVG contexts
 *
 * Mirrors the CSS custom properties defined in :root of App.css.
 * Use these when setting colors in inline styles, SVG attributes,
 * or any context where CSS variables aren't available.
 *
 * ADHD-friendly palette: warm neutral base, sharp red/green semantics,
 * blue for trust (needs), warm amber for wants.
 */

const theme = {
  // Primary — warm charcoal
  primary: '#2d2926',
  primaryHover: '#3d3935',
  primaryLight: '#4d4944',

  // Semantic
  success: '#2d8a4e',
  successDark: '#246e3e',
  successLight: '#10b981',
  danger: '#c0392b',
  dangerDark: '#a0311f',
  dangerLight: '#e74c3c',
  warning: '#d4762c',

  // Bucket colors
  bucketNeed: '#3b82f6',
  bucketWant: '#e8933a',
  bucketSavings: '#2d8a4e',
  bucketIncome: '#10b981',

  // Backgrounds — warm off-white
  bg: '#e2ddd7',
  bgCard: 'rgba(255, 253, 250, 0.6)',
  bgHero: '#faf8f6',
  bgHover: '#faf9f7',
  bgInput: '#f5f3f0',
  bgSkeleton: '#e8e5e1',

  // Bucket tint backgrounds — subtle row washes
  tintNeed: '#eef4fe',
  tintWant: '#fef6ed',
  tintSavings: '#eef8f0',
  tintIncome: '#e8faf2',

  // Borders — warm grays
  border: '#e3dfda',
  borderLight: '#eeebe7',
  borderInput: '#dad7d2',
  borderHeavy: '#ece9e5',

  // Text — warm grays
  text: '#2d2926',
  textDark: '#36322f',
  textMedium: '#5a5550',
  textSecondary: '#6b665f',
  textMuted: '#8a847d',
  textFaint: '#b5b0a9',
  textFaintest: '#c9c4bd',

  // Fire card
  fireBg: '#fff5f5',
  fireBorder: '#fed7d7',
};

export default theme;
